/** Recent Firebase auth_time required for sensitive admin mutations (ADR-0018). */
export const STEP_UP_MAX_AGE_SECONDS = 5 * 60;

export const STEP_UP_REQUIRED_ERROR = 'step-up-required';

export const STEP_UP_REQUIRED_MESSAGE =
  'Deleting users or copying a sign-in link needs a sign-in from the last 5 minutes. Click Sign in again, then retry that action.';

export const STEP_UP_LOGIN_MINT_MESSAGE =
  'Your previous sign-in is too old to open a new session. Use Sign in with Google, or request a new email link below. Do not click an old email link again.';

export function loginMintStepUpFailure() {
  return {
    error: STEP_UP_REQUIRED_ERROR,
    message: STEP_UP_LOGIN_MINT_MESSAGE,
    reason: { kind: STEP_UP_REQUIRED_ERROR },
  };
}

export function isStepUpFresh(
  authTimeSeconds: number | null | undefined,
  nowSeconds: number = Math.floor(Date.now() / 1000),
): boolean {
  if (authTimeSeconds == null || !Number.isFinite(authTimeSeconds)) {
    return false;
  }
  return nowSeconds - authTimeSeconds <= STEP_UP_MAX_AGE_SECONDS;
}

export function stepUpFailure() {
  return {
    error: STEP_UP_REQUIRED_ERROR,
    message: STEP_UP_REQUIRED_MESSAGE,
    reason: { kind: STEP_UP_REQUIRED_ERROR },
  };
}

function failureText(error: unknown): string {
  if (typeof error === 'string') {
    return error;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return String(error ?? '');
}

/** True when copy-link / Delete should open the step-up dialog instead of a generic toast. */
export function isStepUpRequiredFailure(error: unknown): boolean {
  const code = (error as { code?: string } | null)?.code;
  const text = failureText(error);
  if (code === STEP_UP_REQUIRED_ERROR || text.includes(STEP_UP_REQUIRED_ERROR)) {
    return true;
  }
  // Hosted HTTP/2 often has an empty statusText. Access 403 bodies that only
  // expose `reason.kind` used to become `HTTP 403: ` and never opened step-up.
  return /^HTTP 403:\s*$/.test(text);
}
